import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export default function AdminReset() {
  const nav = useNavigate();
  const [step, setStep] = useState("request");
  const [f, setF] = useState({ email: "", code: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (step === "reset" && f.new_password !== f.confirm) { setError("Passwords don't match."); return; }
    setBusy(true);
    try {
      if (step === "request") {
        const { data } = await api.post("/auth/forgot-password", { email: f.email });
        toast.success(data.message);
        setStep("reset");
      } else {
        const { data } = await api.post("/auth/reset-password", { email: f.email, code: f.code, new_password: f.new_password });
        toast.success(data.message);
        nav("/admin/login");
      }
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-[hsl(var(--cream))]">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-border rounded-lg p-8 space-y-5" data-testid="admin-reset-form">
        <div><p className="eyebrow">Owner dashboard</p><h1 className="text-3xl mt-2">Reset password</h1>
          <p className="text-sm text-muted-foreground mt-2">{step === "request" ? "Enter your owner email and we'll send you a reset code." : "Check your email for the 8-character code, then choose a new password."}</p></div>
        <div className="space-y-1.5"><Label htmlFor="r-email">Email</Label><Input id="r-email" type="email" required value={f.email} onChange={set("email")} disabled={step === "reset"} data-testid="reset-email-input" /></div>
        {step === "reset" && (<>
          <div className="space-y-1.5"><Label htmlFor="r-code">Reset code</Label><Input id="r-code" required value={f.code} onChange={set("code")} autoComplete="one-time-code" data-testid="reset-code-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="r-pw">New password (min 8 characters)</Label><Input id="r-pw" type="password" required minLength={8} value={f.new_password} onChange={set("new_password")} data-testid="reset-new-password-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="r-pw2">Confirm new password</Label><Input id="r-pw2" type="password" required minLength={8} value={f.confirm} onChange={set("confirm")} data-testid="reset-confirm-password-input" /></div>
        </>)}
        {error && <p className="text-sm text-destructive" role="alert" data-testid="reset-error">{error}</p>}
        <button disabled={busy} className="w-full bg-primary text-primary-foreground py-3 rounded-full font-semibold disabled:opacity-60" data-testid="reset-submit-button">{busy ? "Please wait…" : step === "request" ? "Send reset code" : "Set new password"}</button>
        <div className="flex justify-between text-sm">
          <Link to="/admin/login" className="underline" data-testid="reset-back-to-login">Back to sign in</Link>
          {step === "reset" && <button type="button" onClick={() => setStep("request")} className="underline" data-testid="reset-resend-code">Send a new code</button>}
        </div>
      </form>
    </div>
  );
}
